import { QuoteCarousel } from './quote-carousel.component';

export * from './quote-carousel.component';
export default QuoteCarousel;

QuoteCarousel.define('der-ui-quote-carousel');

declare global {
    interface HTMLElementTagNameMap {
        'quote-carousel': QuoteCarousel;
    }
}
